import React from 'react';
import styled from 'styled-components';

const Bar = styled.section`
  padding: 2.5rem 1rem;
  background: var(--background-dark);
  border-top: 1px solid rgba(0,153,0,0.15);
  border-bottom: 1px solid rgba(0,153,0,0.15);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  align-items: center;
  text-align: center;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 500px) { grid-template-columns: 1fr; gap: 1rem; }

  .item {
    color: var(--text-secondary);
    font-size: 0.9rem;
    strong { display: block; color: var(--text-color); font-weight: 800; font-size: 1.1rem; margin-bottom: 0.15rem; }
  }
`;

const TrustBar: React.FC = () => (
  <Bar>
    <Inner>
      <div className="item"><strong>Instant Delivery</strong>License by email in minutes</div>
      <div className="item"><strong>BTC &amp; USDT Accepted</strong>Pay with major crypto</div>
      <div className="item"><strong>24/7 WhatsApp Support</strong>Real humans, real fast</div>
      <div className="item"><strong>Licensed &amp; Trusted</strong>1000+ happy customers</div>
    </Inner>
  </Bar>
);

export default TrustBar;
